import { MenuTranslation } from '@/assets/locales/menu/menu.translation.en.ts';
import {
  MenuGroups,
  MenuItemEnum,
} from '@/components/layout/sidebar/sideBarMenu/model/SideBarMenuItems.model.tsx';

export const menuTranslation: MenuTranslation = {
  group: {
    [MenuGroups.ADMIN]: 'wymagaAktualizacji',
    [MenuGroups.AREA]: 'wymagaAktualizacji',
    [MenuGroups.CERTIFICATION]: 'wymagaAktualizacji',
    [MenuGroups.EMPLOYEE_PROFILE]: 'wymagaAktualizacji',
    [MenuGroups.EMPLOYEE_PROFILES_SEARCH]: 'wymagaAktualizacji',
    [MenuGroups.EMPLOYEE_PROFILES_SEARCH_AI]: 'wymagaAktualizacji',
    [MenuGroups.GROUP_TRAININGS]: 'wymagaAktualizacji',
    [MenuGroups.KNOW_ME]: 'wymagaAktualizacji',
    [MenuGroups.NOTIFICATIONS]: 'wymagaAktualizacji',
    [MenuGroups.STRUCTURE]: 'wymagaAktualizacji',
    [MenuGroups.SUCCESSION]: 'wymagaAktualizacji',
    [MenuGroups.TEAM]: 'wymagaAktualizacji',
    [MenuGroups.USERS_LIST]: 'wymagaAktualizacji',
  },
  item: {
    [MenuItemEnum.ADMIN]: 'Panel admina',
    [MenuItemEnum.AREA]: 'Podległy obszar',
    [MenuItemEnum.CERTIFICATION]: 'Certyfikacja',
    [MenuItemEnum.CONTACT]: 'Kontakt',
    [MenuItemEnum.EMPLOYEE_PROFILE]: 'Mój profil',
    [MenuItemEnum.EMPLOYEE_PROFILES_SEARCH]: 'Wyszukiwanie Pracowników',
    [MenuItemEnum.EMPLOYEE_PROFILES_SEARCH_AI]: 'Dopasowanie pracowników do stanowiska',
    [MenuItemEnum.GROUP_TRAININGS]: 'Szkolenia dla grup',
    [MenuItemEnum.KNOW_ME]: 'KnowMe',
    [MenuItemEnum.NESTED_STRUCTURE]: 'Struktura zagnieżdżona',
    [MenuItemEnum.NEWS]: 'Aktualności',
    [MenuItemEnum.NOTIFICATIONS]: 'Powiadomienia',
    [MenuItemEnum.ORGANIZATION_CHART]: 'Struktura',
    [MenuItemEnum.SUCCESSION]: 'Zarządzaj sukcesją',
    [MenuItemEnum.SUCCESSION_CHANGELOG]: 'Dziennik zmian sukcesji',
    [MenuItemEnum.TEAM]: 'Mój zespół',
    [MenuItemEnum.USERS_LIST]: 'Panel admina',
  },
};
